<template>
    <rkm-form>
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-col cols="12">
                    <rkm-form-checkbox
                        v-model="data.model.dorToracica"
                        @change="resetDados"
                    >
                        Dor torácica
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-col>
        </rkm-row>

         <rkm-row v-if="data.model.dorToracica">
            <rkm-col>

                <rkm-col cols="12">
                    <rkm-area
                        title="Formulário de coleta de dados"
                    >
                        <rkm-row>
                            <rkm-col cols="3">
                                <rkm-form-date-picker
                                    label="Data do inicio do sintoma"
                                    v-model="data.model.dorToracicaDataSintoma"
                                    :max-date="data.form.dataAtual"
                                    :validations="validations.dorToracicaDataSintoma"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-time-picker
                                    label="Hora do inicio do sintoma"
                                    ref="horaInicial"
                                    v-model="data.model.dorToracicaHoraSintoma"
                                    :validations="validations.dorToracicaHoraSintoma"
                                    :disabled="!data.model.dorToracicaDataSintoma"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-area
                                title="Caracteristica da dor*"
                                no-margin-top
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <rkm-form-group>
                                            <rkm-form-checkbox-group
                                                name="Caracteristica da dor"
                                                v-model="data.model.dorToracicaCaracteristicaDor"
                                                :validations="validations.dorToracicaCaracteristicaDor"
                                            >
                                                <rkm-row>
                                                    <rkm-col
                                                        v-for="item in caracteristicaDor"
                                                        v-bind:key="item.id"
                                                        cols="4"
                                                    >
                                                        <rkm-form-checkbox
                                                            :value="item.id"
                                                            class="text-nowrap"
                                                            inline
                                                        >
                                                            {{ item.nome }}
                                                        </rkm-form-checkbox>
                                                    </rkm-col>
                                                </rkm-row>
                                            </rkm-form-checkbox-group>
                                        </rkm-form-group>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-area
                                title="Localização da dor*"
                                no-margin-top
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <rkm-form-group>
                                            <rkm-form-checkbox-group
                                                name="Localização da dor"
                                                v-model="data.model.dorToracicaLocalizacaoDor"
                                                :validations="validations.dorToracicaLocalizacaoDor"
                                            >
                                                <rkm-row>
                                                    <rkm-col
                                                        v-for="item in localizacaoDor"
                                                        v-bind:key="item.id"
                                                        cols="4"
                                                    >
                                                        <rkm-form-checkbox
                                                            :value="item.id"
                                                            class="text-nowrap"
                                                            inline
                                                        >
                                                            {{ item.nome }}
                                                        </rkm-form-checkbox>
                                                    </rkm-col>
                                                </rkm-row>
                                            </rkm-form-checkbox-group>
                                        </rkm-form-group>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-area
                                title="Fator desencadeante*"
                                no-margin-top
                            >

                                <rkm-row>
                                    <rkm-col>
                                        <rkm-form-group>
                                            <rkm-form-checkbox-group
                                                name="Fator desencadeante"
                                                v-model="data.model.dorToracicaFatorDescadeante"
                                                :validations="validations.dorToracicaFatorDescadeante"
                                            >
                                                <rkm-row>
                                                    <rkm-col
                                                        v-for="item in fatorDesencadeante"
                                                        v-bind:key="item.id"
                                                        cols="4"
                                                    >
                                                        <rkm-form-checkbox
                                                            :value="item.id"
                                                            class="text-nowrap"
                                                            inline
                                                        >
                                                            {{ item.nome }}
                                                        </rkm-form-checkbox>
                                                    </rkm-col>
                                                </rkm-row>
                                            </rkm-form-checkbox-group>
                                        </rkm-form-group>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-area
                                title="Duração da dor*"
                                no-margin-top
                            >
                                <rkm-row>
                                    <rkm-col cols="12">
                                        <rkm-form-checkbox-group
                                            :options="duracaoDor"
                                            class="mx-2"
                                            name="Duração da dor"
                                            text-field="nome"
                                            v-model="data.model.dorToracicaDuracaoDor"
                                            value-field="id"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>

                        <rkm-col cols="3">
                            <rkm-area
                                title="Acompanhada de dispneia*"
                                no-margin-top
                            >
                                <rkm-form-radio-group
                                    name="Acompanhada de dispneia"
                                    v-model="data.model.dorToracicaDispneia"
                                    :validations="validations.dorToracicaDispneia"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-area title="Fatores de risco">

                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-checkbox-group
                                    :options="fatorRiscoToracica"
                                    name="Fatores de risco"
                                    text-field="nome"
                                    v-model="data.model.dorToracicaFatoresRiscos"
                                    :validations="validations.dorToracicaFatoresRiscos"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-area
                        title="Continuidade do atendimento - Encaminhar para a emergência"
                    >
                        <rkm-row>
                            <rkm-col cols="3">
                                <rkm-form-date-picker
                                    label="Data ECG de admissão"
                                    v-model="data.model.dorToracicaDataEcgAdmissao"
                                    :validations="validations.dorToracicaDataSintoma"
                                    :disabled="!data.model.dorToracicaHoraSintoma"
                                    :min-date="formatDate()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-time-picker
                                    label="Hora ECG de admissão"
                                    v-model="data.model.dorToracicaHoraEcgAdmissao"
                                    :validations="data.model.dorToracicaHoraEcgAdmissao ? validations.dorToracicaHoraEcgAdmissao : {}"
                                    :disabled="verificaHora() ? true : false"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-col >
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { error, repository, stringCase, data, object, mask } from '@/mixins'

// Moment.
import moment from 'moment'

// Filters.
import format from '@/filters/formats'

//Enum
import StatusToracica from '@/enums/pronto-atendimento/statusDorToracica'


export default {
    computed: {
        validations() {

            const validations = {};

            if (this.data.model.dorToracica) {

                validations.dorToracicaDataSintoma = { required: true };
                validations.dorToracicaHoraSintoma = {
                    required: true,
                    max_hour: moment(this.data.form.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD') ===
                        this.getFormatedDate(this.data.model.dorToracicaDataSintoma, 'YYYY-MM-DD')
                        ? moment().format("HH:mm") : false
                };

                validations.dorToracicaDataEcgAdmissao = { required: true };
                validations.dorToracicaHoraEcgAdmissao = {
                    required: true,

                    min_hour: this.getFormatedDate(this.data.model.dorToracicaDataSintoma, 'YYYY-MM-DD')
                        === this.getFormatedDate(this.data.model.dorToracicaDataEcgAdmissao, 'YYYY-MM-DD')
                        ? this.getMinHour() : false
                };

                validations.dorToracicaCaracteristicaDor = { required: true };
                validations.dorToracicaLocalizacaoDor = { required: true };
                validations.dorToracicaFatorDescadeante = { required: true };
                validations.dorToracicaDuracaoDor = { required: true };
                validations.dorToracicaFatoresRiscos = { required: true };
                validations.dorToracicaDispneia = { required: true };
            }

            return validations;
        },
        caracteristicaDor(){

            return this.data.form.formularioDorToracica.caracteristicaDor
        },
        localizacaoDor(){

            return this.data.form.formularioDorToracica.localizacaoDor
        },
        fatorDesencadeante(){

            return this.data.form.formularioDorToracica.fatorDesencadeante
        },
        fatorRiscoToracica(){

            return this.data.form.formularioDorToracica.fatoresRiscoToracica.map(option => {
                if (option.id === StatusToracica.IDADE_MAIOR_SESSENTA) {
                    option.nome = "Idade > 60 anos";
                }
                return option;
            });
        },
        duracaoDor(){

            return this.data.form.formularioDorToracica.duracaoDor.map(option => {
                if (option.id === StatusToracica.DURACAO_DA_DOR) {
                    option.nome = "> que 5 minutos";
                }
                return option;
            });
        }

    },
    filters: {
        ...format,
    },
   data: () => ({
        desabilitaVolta: false,
        enums: { StatusToracica }
    }),
    methods: {
        resetDados() {
            if (!this.data.model.dorToracica) {

                this.data.model.dorToracicaDataSintoma = null
                this.data.model.dorToracicaHoraSintoma = null
                this.data.model.dorToracicaDataEcgAdmissao = null
                this.data.model.dorToracicaHoraEcgAdmissao = null
                this.data.model.dorToracicaCaracteristicaDor = []
                this.data.model.dorToracicaLocalizacaoDor = []
                this.data.model.dorToracicaFatorDescadeante = []
                this.data.model.dorToracicaDuracaoDor = []
                this.data.model.dorToracicaFatoresRiscos = []
                this.data.model.dorToracicaDispneia = []
            }
        },
        getMinHour() {

            const horario = this.data.model.dorToracicaHoraSintoma

            if (horario) {

                return moment(horario, 'HH:mm').add(1, 'minutes').format('HH:mm')
            }

            return false
        },
        formatDate() {

            const data = this.data.model.dorToracicaDataSintoma
            const hora = this.data.model.dorToracicaHoraSintoma

            if(!hora){

                this.data.model.dorToracicaDataEcgAdmissao = null
            }

            if (data) {

                return moment(data, 'DD/MM/YYYY').format('DD/MM/YYYY')
            }

            return false
        },
        verificaHora(){

            const dataIn = this.data.model.dorToracicaDataSintoma
            const dataFn = this.data.model.dorToracicaDataEcgAdmissao

            if(dataFn < dataIn){

               this.data.model.dorToracicaHoraEcgAdmissao = null

               return true
            }

            if (!dataIn){

                return true
            }

            return false
        }
    },
    mixins: [ error, repository, stringCase, data, object, mask ],
    props: {
        data: { type: Object, required: true }
    },
}
</script>
